<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
:root {
  --yellow: #ffd200;
  --yellow-deep: #f5b700;
  --ink: #2b2b2b;
  --grey: #888;
  --grey-light: #d8d8d8;
  --grey-bg: #dadcde;
  --maxw: 1200px;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 50px;
}

body {
  color: var(--ink);
  background: #fff;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

img {
  display: block;
  max-width: 100%;
}

a {
  color: inherit;
  text-decoration: none;
}

.container {
  width: 100%;
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 0;
}

#app {
  min-height: 100vh;
}

@media (max-width: 1240px) {
  .container {
    padding-right: 24px;
    padding-left: 24px;
  }
}
</style>
